"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/external-card.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Fexternal-card.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.externalCardEntryMethodToJSON = exports.externalCardEntryMethodFromJSON = exports.externalCardTypeToJSON = exports.externalCardTypeFromJSON = exports.externalCardProviderToJSON = exports.externalCardProviderFromJSON = exports.ProviderPayoutDetails = exports.StripeToken = exports.TestCardToken = exports.TabaPayToken = exports.CardToken = exports.ExternalCard = exports.ExternalCardEntryMethod = exports.ExternalCardType = exports.ExternalCardProvider = void 0;
const address_1 = require("./address");
const date_1 = require("./date");
const external_card_payout_1 = require("./external-card-payout");
const legal_name_1 = require("./legal-name");
const wallet_provider_1 = require("./wallet-provider");
const protobufPackage = 'com.step.common.proto';
var ExternalCardProvider;
(function (ExternalCardProvider) {
    ExternalCardProvider["INVALID_PROVIDER"] = "INVALID_PROVIDER";
    ExternalCardProvider["TEST"] = "TEST";
    ExternalCardProvider["STRIPE"] = "STRIPE";
    ExternalCardProvider["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ExternalCardProvider || (exports.ExternalCardProvider = ExternalCardProvider = {}));
var ExternalCardType;
(function (ExternalCardType) {
    ExternalCardType["INVALID_FUNDING_CARD_TYPE"] = "INVALID_FUNDING_CARD_TYPE";
    ExternalCardType["DEBIT"] = "DEBIT";
    ExternalCardType["CREDIT"] = "CREDIT";
    ExternalCardType["PREPAID"] = "PREPAID";
    ExternalCardType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ExternalCardType || (exports.ExternalCardType = ExternalCardType = {}));
var ExternalCardEntryMethod;
(function (ExternalCardEntryMethod) {
    ExternalCardEntryMethod["INVALID_EXTERNAL_CARD_ENTRY_METHOD"] = "INVALID_EXTERNAL_CARD_ENTRY_METHOD";
    ExternalCardEntryMethod["MANUAL"] = "MANUAL";
    ExternalCardEntryMethod["SCANNED"] = "SCANNED";
    ExternalCardEntryMethod["EPHEMERAL"] = "EPHEMERAL";
    ExternalCardEntryMethod["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ExternalCardEntryMethod || (exports.ExternalCardEntryMethod = ExternalCardEntryMethod = {}));
function createBaseExternalCard() {
    return {
        userReferenceId: '',
        accountReferenceId: '',
        provider: ExternalCardProvider.INVALID_PROVIDER,
        panSuffix: '',
        expirationDate: date_1.ExpirationDate.fromPartial({}),
        network: '',
        cardType: ExternalCardType.INVALID_FUNDING_CARD_TYPE,
        avsZip: '',
        nameOnCard: '',
        fingerprint: '',
        entryMethod: ExternalCardEntryMethod.INVALID_EXTERNAL_CARD_ENTRY_METHOD,
        providerPayoutDetails: undefined,
        issuer: '',
        walletProvider: wallet_provider_1.WalletProvider.NOT_A_WALLET_PROVIDER,
    };
}
exports.ExternalCard = {
    fromJSON(object) {
        const message = {
            accountReferenceId: isSet(object.accountReferenceId)
                ? globalThis.String(object.accountReferenceId)
                : '',
            provider: isSet(object.provider)
                ? externalCardProviderFromJSON(object.provider)
                : ExternalCardProvider.INVALID_PROVIDER,
            panSuffix: isSet(object.panSuffix) ? globalThis.String(object.panSuffix) : '',
            expirationDate: isSet(object.expirationDate)
                ? date_1.ExpirationDate.fromJSON(object.expirationDate)
                : date_1.ExpirationDate.fromPartial({}),
            network: isSet(object.network) ? globalThis.String(object.network) : '',
            cardType: isSet(object.cardType)
                ? externalCardTypeFromJSON(object.cardType)
                : ExternalCardType.INVALID_FUNDING_CARD_TYPE,
        };
        if (isSet(object.userReferenceId)) {
            message.userReferenceId = globalThis.String(object.userReferenceId);
        }
        if (isSet(object.avsZip)) {
            message.avsZip = globalThis.String(object.avsZip);
        }
        if (isSet(object.nameOnCard)) {
            message.nameOnCard = globalThis.String(object.nameOnCard);
        }
        if (isSet(object.fingerprint)) {
            message.fingerprint = globalThis.String(object.fingerprint);
        }
        if (isSet(object.entryMethod)) {
            message.entryMethod = externalCardEntryMethodFromJSON(object.entryMethod);
        }
        if (isSet(object.providerPayoutDetails)) {
            message.providerPayoutDetails = exports.ProviderPayoutDetails.fromJSON(object.providerPayoutDetails);
        }
        if (isSet(object.issuer)) {
            message.issuer = globalThis.String(object.issuer);
        }
        if (isSet(object.walletProvider)) {
            message.walletProvider = (0, wallet_provider_1.walletProviderFromJSON)(object.walletProvider);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userReferenceId !== undefined && message.userReferenceId !== '') {
            obj.userReferenceId = message.userReferenceId;
        }
        if (message.accountReferenceId !== '') {
            obj.accountReferenceId = message.accountReferenceId;
        }
        if (message.provider !== ExternalCardProvider.INVALID_PROVIDER) {
            obj.provider = externalCardProviderToJSON(message.provider);
        }
        if (message.panSuffix !== '') {
            obj.panSuffix = message.panSuffix;
        }
        if (message.expirationDate !== undefined) {
            obj.expirationDate = date_1.ExpirationDate.toJSON(message.expirationDate);
        }
        if (message.network !== '') {
            obj.network = message.network;
        }
        if (message.cardType !== ExternalCardType.INVALID_FUNDING_CARD_TYPE) {
            obj.cardType = externalCardTypeToJSON(message.cardType);
        }
        if (message.avsZip !== undefined && message.avsZip !== '') {
            obj.avsZip = message.avsZip;
        }
        if (message.nameOnCard !== undefined && message.nameOnCard !== '') {
            obj.nameOnCard = message.nameOnCard;
        }
        if (message.fingerprint !== undefined && message.fingerprint !== '') {
            obj.fingerprint = message.fingerprint;
        }
        if (message.entryMethod !== undefined &&
            message.entryMethod !== ExternalCardEntryMethod.INVALID_EXTERNAL_CARD_ENTRY_METHOD) {
            obj.entryMethod = externalCardEntryMethodToJSON(message.entryMethod);
        }
        if (message.providerPayoutDetails !== undefined) {
            obj.providerPayoutDetails = exports.ProviderPayoutDetails.toJSON(message.providerPayoutDetails);
        }
        if (message.issuer !== undefined && message.issuer !== '') {
            obj.issuer = message.issuer;
        }
        if (message.walletProvider !== undefined &&
            message.walletProvider !== wallet_provider_1.WalletProvider.NOT_A_WALLET_PROVIDER) {
            obj.walletProvider = (0, wallet_provider_1.walletProviderToJSON)(message.walletProvider);
        }
        return obj;
    },
    create(base) {
        return exports.ExternalCard.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseExternalCard();
        message.userReferenceId = object.userReferenceId ?? '';
        message.accountReferenceId = object.accountReferenceId ?? '';
        message.provider = object.provider ?? ExternalCardProvider.INVALID_PROVIDER;
        message.panSuffix = object.panSuffix ?? '';
        message.expirationDate = (object.expirationDate !== undefined && object.expirationDate !== null)
            ? date_1.ExpirationDate.fromPartial(object.expirationDate)
            : date_1.ExpirationDate.fromPartial({});
        message.network = object.network ?? '';
        message.cardType = object.cardType ?? ExternalCardType.INVALID_FUNDING_CARD_TYPE;
        message.avsZip = object.avsZip ?? '';
        message.nameOnCard = object.nameOnCard ?? '';
        message.fingerprint = object.fingerprint ?? '';
        message.entryMethod = object.entryMethod ??
            ExternalCardEntryMethod.INVALID_EXTERNAL_CARD_ENTRY_METHOD;
        message.providerPayoutDetails =
            (object.providerPayoutDetails !== undefined && object.providerPayoutDetails !== null)
                ? exports.ProviderPayoutDetails.fromPartial(object.providerPayoutDetails)
                : undefined;
        message.issuer = object.issuer ?? '';
        message.walletProvider = object.walletProvider ?? wallet_provider_1.WalletProvider.NOT_A_WALLET_PROVIDER;
        return message;
    },
};
function createBaseCardToken() {
    return { testCardToken: undefined, stripe: undefined };
}
exports.CardToken = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.testCardToken)) {
            message.testCardToken = exports.TestCardToken.fromJSON(object.testCardToken);
        }
        if (isSet(object.stripe)) {
            message.stripe = exports.StripeToken.fromJSON(object.stripe);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.testCardToken !== undefined) {
            obj.testCardToken = exports.TestCardToken.toJSON(message.testCardToken);
        }
        if (message.stripe !== undefined) {
            obj.stripe = exports.StripeToken.toJSON(message.stripe);
        }
        return obj;
    },
    create(base) {
        return exports.CardToken.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardToken();
        message.testCardToken = (object.testCardToken !== undefined && object.testCardToken !== null)
            ? exports.TestCardToken.fromPartial(object.testCardToken)
            : undefined;
        message.stripe = (object.stripe !== undefined && object.stripe !== null)
            ? exports.StripeToken.fromPartial(object.stripe)
            : undefined;
        return message;
    },
};
function createBaseTabaPayToken() {
    return {
        encryptedCard: '',
        keyId: '',
        cardHolderName: legal_name_1.LegalName.fromPartial({}),
        zip: undefined,
        address: undefined,
    };
}
exports.TabaPayToken = {
    fromJSON(object) {
        const message = {
            encryptedCard: isSet(object.encryptedCard) ? globalThis.String(object.encryptedCard) : '',
            keyId: isSet(object.keyId) ? globalThis.String(object.keyId) : '',
            cardHolderName: isSet(object.cardHolderName)
                ? legal_name_1.LegalName.fromJSON(object.cardHolderName)
                : legal_name_1.LegalName.fromPartial({}),
        };
        if (isSet(object.zip)) {
            message.zip = globalThis.String(object.zip);
        }
        if (isSet(object.address)) {
            message.address = address_1.Address.fromJSON(object.address);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.encryptedCard !== '') {
            obj.encryptedCard = message.encryptedCard;
        }
        if (message.keyId !== '') {
            obj.keyId = message.keyId;
        }
        if (message.cardHolderName !== undefined) {
            obj.cardHolderName = legal_name_1.LegalName.toJSON(message.cardHolderName);
        }
        if (message.zip !== undefined) {
            obj.zip = message.zip;
        }
        if (message.address !== undefined) {
            obj.address = address_1.Address.toJSON(message.address);
        }
        return obj;
    },
    create(base) {
        return exports.TabaPayToken.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTabaPayToken();
        message.encryptedCard = object.encryptedCard ?? '';
        message.keyId = object.keyId ?? '';
        message.cardHolderName = (object.cardHolderName !== undefined && object.cardHolderName !== null)
            ? legal_name_1.LegalName.fromPartial(object.cardHolderName)
            : legal_name_1.LegalName.fromPartial({});
        message.zip = object.zip ?? undefined;
        message.address = (object.address !== undefined && object.address !== null)
            ? address_1.Address.fromPartial(object.address)
            : undefined;
        return message;
    },
};
function createBaseTestCardToken() {
    return {
        pan: '',
        expirationDate: date_1.ExpirationDate.fromPartial({}),
        cvv: '',
        zip: '',
        cardHolderName: undefined,
        fingerprint: '',
        cardType: ExternalCardType.INVALID_FUNDING_CARD_TYPE,
        walletProvider: wallet_provider_1.WalletProvider.NOT_A_WALLET_PROVIDER,
    };
}
exports.TestCardToken = {
    fromJSON(object) {
        const message = {
            pan: isSet(object.pan) ? globalThis.String(object.pan) : '',
            expirationDate: isSet(object.expirationDate)
                ? date_1.ExpirationDate.fromJSON(object.expirationDate)
                : date_1.ExpirationDate.fromPartial({}),
        };
        if (isSet(object.cvv)) {
            message.cvv = globalThis.String(object.cvv);
        }
        if (isSet(object.zip)) {
            message.zip = globalThis.String(object.zip);
        }
        if (isSet(object.cardHolderName)) {
            message.cardHolderName = legal_name_1.LegalName.fromJSON(object.cardHolderName);
        }
        if (isSet(object.fingerprint)) {
            message.fingerprint = globalThis.String(object.fingerprint);
        }
        if (isSet(object.cardType)) {
            message.cardType = externalCardTypeFromJSON(object.cardType);
        }
        if (isSet(object.walletProvider)) {
            message.walletProvider = (0, wallet_provider_1.walletProviderFromJSON)(object.walletProvider);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.pan !== '') {
            obj.pan = message.pan;
        }
        if (message.expirationDate !== undefined) {
            obj.expirationDate = date_1.ExpirationDate.toJSON(message.expirationDate);
        }
        if (message.cvv !== undefined && message.cvv !== '') {
            obj.cvv = message.cvv;
        }
        if (message.zip !== undefined && message.zip !== '') {
            obj.zip = message.zip;
        }
        if (message.cardHolderName !== undefined) {
            obj.cardHolderName = legal_name_1.LegalName.toJSON(message.cardHolderName);
        }
        if (message.fingerprint !== undefined && message.fingerprint !== '') {
            obj.fingerprint = message.fingerprint;
        }
        if (message.cardType !== undefined &&
            message.cardType !== ExternalCardType.INVALID_FUNDING_CARD_TYPE) {
            obj.cardType = externalCardTypeToJSON(message.cardType);
        }
        if (message.walletProvider !== undefined &&
            message.walletProvider !== wallet_provider_1.WalletProvider.NOT_A_WALLET_PROVIDER) {
            obj.walletProvider = (0, wallet_provider_1.walletProviderToJSON)(message.walletProvider);
        }
        return obj;
    },
    create(base) {
        return exports.TestCardToken.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTestCardToken();
        message.pan = object.pan ?? '';
        message.expirationDate = (object.expirationDate !== undefined && object.expirationDate !== null)
            ? date_1.ExpirationDate.fromPartial(object.expirationDate)
            : date_1.ExpirationDate.fromPartial({});
        message.cvv = object.cvv ?? '';
        message.zip = object.zip ?? '';
        message.cardHolderName = (object.cardHolderName !== undefined && object.cardHolderName !== null)
            ? legal_name_1.LegalName.fromPartial(object.cardHolderName)
            : undefined;
        message.fingerprint = object.fingerprint ?? '';
        message.cardType = object.cardType ?? ExternalCardType.INVALID_FUNDING_CARD_TYPE;
        message.walletProvider = object.walletProvider ?? wallet_provider_1.WalletProvider.NOT_A_WALLET_PROVIDER;
        return message;
    },
};
function createBaseStripeToken() {
    return { token: undefined, paymentMethod: undefined };
}
exports.StripeToken = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.token)) {
            message.token = globalThis.String(object.token);
        }
        if (isSet(object.paymentMethod)) {
            message.paymentMethod = globalThis.String(object.paymentMethod);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.token !== undefined) {
            obj.token = message.token;
        }
        if (message.paymentMethod !== undefined) {
            obj.paymentMethod = message.paymentMethod;
        }
        return obj;
    },
    create(base) {
        return exports.StripeToken.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStripeToken();
        message.token = object.token ?? undefined;
        message.paymentMethod = object.paymentMethod ?? undefined;
        return message;
    },
};
function createBaseProviderPayoutDetails() {
    return {
        accountReferenceId: '',
        userReferenceId: '',
        availablePayoutMethods: [],
        isErrored: false,
    };
}
exports.ProviderPayoutDetails = {
    fromJSON(object) {
        const message = {
            userReferenceId: isSet(object.userReferenceId)
                ? globalThis.String(object.userReferenceId)
                : '',
            isErrored: isSet(object.isErrored) ? globalThis.Boolean(object.isErrored) : false,
        };
        if (isSet(object.accountReferenceId)) {
            message.accountReferenceId = globalThis.String(object.accountReferenceId);
        }
        if (globalThis.Array.isArray(object?.availablePayoutMethods)) {
            message.availablePayoutMethods = object.availablePayoutMethods.map((e) => (0, external_card_payout_1.payoutMethodFromJSON)(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountReferenceId !== undefined && message.accountReferenceId !== '') {
            obj.accountReferenceId = message.accountReferenceId;
        }
        if (message.userReferenceId !== '') {
            obj.userReferenceId = message.userReferenceId;
        }
        if (message.availablePayoutMethods?.length) {
            obj.availablePayoutMethods = message.availablePayoutMethods.map((e) => (0, external_card_payout_1.payoutMethodToJSON)(e));
        }
        if (message.isErrored !== false) {
            obj.isErrored = message.isErrored;
        }
        return obj;
    },
    create(base) {
        return exports.ProviderPayoutDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseProviderPayoutDetails();
        message.accountReferenceId = object.accountReferenceId ?? '';
        message.userReferenceId = object.userReferenceId ?? '';
        message.availablePayoutMethods = object.availablePayoutMethods?.map((e) => e) || [];
        message.isErrored = object.isErrored ?? false;
        return message;
    },
};
function externalCardProviderFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_PROVIDER':
            return ExternalCardProvider.INVALID_PROVIDER;
        case 1:
        case 'TEST':
            return ExternalCardProvider.TEST;
        case 3:
        case 'STRIPE':
            return ExternalCardProvider.STRIPE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ExternalCardProvider.UNRECOGNIZED;
    }
}
exports.externalCardProviderFromJSON = externalCardProviderFromJSON;
function externalCardProviderToJSON(object) {
    switch (object) {
        case ExternalCardProvider.INVALID_PROVIDER:
            return 'INVALID_PROVIDER';
        case ExternalCardProvider.TEST:
            return 'TEST';
        case ExternalCardProvider.STRIPE:
            return 'STRIPE';
        case ExternalCardProvider.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.externalCardProviderToJSON = externalCardProviderToJSON;
function externalCardTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_FUNDING_CARD_TYPE':
            return ExternalCardType.INVALID_FUNDING_CARD_TYPE;
        case 1:
        case 'DEBIT':
            return ExternalCardType.DEBIT;
        case 2:
        case 'CREDIT':
            return ExternalCardType.CREDIT;
        case 3:
        case 'PREPAID':
            return ExternalCardType.PREPAID;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ExternalCardType.UNRECOGNIZED;
    }
}
exports.externalCardTypeFromJSON = externalCardTypeFromJSON;
function externalCardTypeToJSON(object) {
    switch (object) {
        case ExternalCardType.INVALID_FUNDING_CARD_TYPE:
            return 'INVALID_FUNDING_CARD_TYPE';
        case ExternalCardType.DEBIT:
            return 'DEBIT';
        case ExternalCardType.CREDIT:
            return 'CREDIT';
        case ExternalCardType.PREPAID:
            return 'PREPAID';
        case ExternalCardType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.externalCardTypeToJSON = externalCardTypeToJSON;
function externalCardEntryMethodFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_EXTERNAL_CARD_ENTRY_METHOD':
            return ExternalCardEntryMethod.INVALID_EXTERNAL_CARD_ENTRY_METHOD;
        case 1:
        case 'MANUAL':
            return ExternalCardEntryMethod.MANUAL;
        case 2:
        case 'SCANNED':
            return ExternalCardEntryMethod.SCANNED;
        case 3:
        case 'EPHEMERAL':
            return ExternalCardEntryMethod.EPHEMERAL;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ExternalCardEntryMethod.UNRECOGNIZED;
    }
}
exports.externalCardEntryMethodFromJSON = externalCardEntryMethodFromJSON;
function externalCardEntryMethodToJSON(object) {
    switch (object) {
        case ExternalCardEntryMethod.INVALID_EXTERNAL_CARD_ENTRY_METHOD:
            return 'INVALID_EXTERNAL_CARD_ENTRY_METHOD';
        case ExternalCardEntryMethod.MANUAL:
            return 'MANUAL';
        case ExternalCardEntryMethod.SCANNED:
            return 'SCANNED';
        case ExternalCardEntryMethod.EPHEMERAL:
            return 'EPHEMERAL';
        case ExternalCardEntryMethod.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.externalCardEntryMethodToJSON = externalCardEntryMethodToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=external-card.js.map